import React from "react";
import { TBA_COUNT } from "@/components/camps/campConfig";

export const TbaCamps = ({ c }) => (
  <div className="mt-16">
    <div className="overline text-[#5E6470]">{c.tbaLabel}</div>
    <span className="gold-rule mt-4 block" />
    <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0F1B2D]/10">
      {(c.tbaLocations || Array.from({ length: TBA_COUNT })).map((loc, i) => (
        <div
          key={`tba-${i}`}
          data-testid={`camp-tba-${i}`}
          className="bg-[#F4F0E8]/60 p-8 min-h-[200px] flex flex-col justify-between"
        >
          <span className="inline-block self-start text-[10px] tracking-[0.24em] uppercase font-bold px-3 py-1 border border-[#C4A46A]/70 text-[#C4A46A]">
            {c.tbaBadge}
          </span>
          <div>
            <div className="font-display text-[#0F1B2D] text-2xl lg:text-3xl leading-none tracking-tight">
              {loc || c.tbaCard}
            </div>
            <div className="mt-3 font-cormorant italic text-[#5E6470] text-sm">{c.tbaCard}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
